"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withIEPolyfill = _interopRequireDefault(require("gatsby-image/withIEPolyfill"));

var _gatsbyBackgroundImage = _interopRequireDefault(require("gatsby-background-image"));
/* eslint-disable import/no-extraneous-dependencies */


var Image = function Image(_ref) {
  var mediaType = _ref.mediaType,
      src = _ref.src,
      fixed = _ref.fixed,
      fluid = _ref.fluid,
      alt = _ref.alt,
      children = _ref.children,
      aspectRatio = _ref.aspectRatio,
      objectFit = _ref.objectFit,
      rest = _objectWithoutProperties(_ref, ["mediaType", "src", "fixed", "fluid", "alt", "children", "aspectRatio", "objectFit"]);

  var fluidSrc = src && {
    fluid: {
      base64: '',
      aspectRatio: aspectRatio,
      src: src,
      srcSet: src,
      srcWebp: '',
      srcSetWebp: '',
      sizes: '(max-width: 1200px) 100vw, 1200px'
    },
    objectFit: objectFit
  };
  return mediaType === 'backgroundImage' ? /*#__PURE__*/_react.default.createElement(_gatsbyBackgroundImage.default, Object.assign({
    fluid: fluid,
    fixed: fixed,
    alt: alt
  }, rest, fluidSrc), children) : /*#__PURE__*/_react.default.createElement(_withIEPolyfill.default, Object.assign({
    fluid: fluid,
    fixed: fixed,
    alt: alt,
    objectFit: "contain"
  }, rest, fluidSrc), children);
};

Image.propTypes = {
  fluid: _propTypes.default.shape({
    base64: _propTypes.default.string,
    aspectRatio: _propTypes.default.number,
    src: _propTypes.default.string,
    srcSet: _propTypes.default.string,
    srcSetWebp: _propTypes.default.string,
    sizes: _propTypes.default.string
  }),
  fixed: _propTypes.default.shape({
    base64: _propTypes.default.string,
    aspectRatio: _propTypes.default.number,
    src: _propTypes.default.string,
    srcSet: _propTypes.default.string,
    srcSetWebp: _propTypes.default.string,
    sizes: _propTypes.default.string
  }),
  alt: _propTypes.default.string,
  children: _propTypes.default.node,
  mediaType: _propTypes.default.string,
  src: _propTypes.default.string,
  aspectRatio: _propTypes.default.number,
  objectFit: _propTypes.default.string
};
Image.defaultProps = {
  alt: '',
  fluid: null,
  fixed: null,
  mediaType: 'image',
  src: null,
  children: null,
  aspectRatio: 1.77,
  objectFit: 'contain'
};
var _default = Image;
exports.default = _default;